import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icons } from '../../Icons';

import styles from './styles.module.scss';

export const NoTemplatesFound = (props) => {
  const { className, templatesName, placeholderIcon, placeholderText } = props;

  return (
    <div className={classNames(styles.noTemplates, className)}>
      <div className={styles.noTemplatesIcon}>
        {placeholderIcon || <Icons variant={Icons.EMPTY_TASK} />}
      </div>
      <div>
        {placeholderText ||
          `You don’t have any 
        ${templatesName || ''} 
        templates`}
      </div>
    </div>
  );
};

NoTemplatesFound.propTypes = {
  className: PropTypes.string,
  templatesName: PropTypes.string,
  placeholderText: PropTypes.string,
  placeholderIcon: PropTypes.element,
};

NoTemplatesFound.defaultProps = {
  className: '',
  templatesName: '',
  placeholderText: '',
  placeholderIcon: undefined,
};
